import React, { Component } from "react";
import close_btn from '../../../images/close_btn.svg';
import uploadIcon from '../../../images/upload.png';
import uploadSuccess from '../../../images/upload-success.png';
import { userService } from "../../../_services";
class EditSheet extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userName: '',
            userId: '',
            sheetTitle: '',
            sheetLink: '',
            file: '',
            fileId: '',
            formError: '',
            formSuccess: '',
            isLoading: false,
            selectedFile: ''
        }
    }
    componentDidMount() {
        let Usermeta_Data = window.atob(localStorage.getItem('ajs_user_id'));
        this.setState({ userId: Usermeta_Data.split(':')[0], userName: Usermeta_Data.split(':')[1] })
        if (this.props.sheetData) {
            this.setState({ sheetTitle: this.props.sheetData.fileName, sheetLink: this.props.sheetData.filePath, fileId: this.props.sheetData.fileId })
        }
    }

    addDocMediaFile() {
        try {
            const fileInput = document.getElementById("file_upload");
            const { selectedFile } = this.state;

            if (!fileInput || fileInput.files.length === 0) {
                this.setState({ formError: "Please select a valid file." });
                return;
            }

            const file = fileInput.files[0];
            const fileType = file.type;
            const fileSize = file.size;

            const allowedTypes = ["application/pdf"];
            if (!allowedTypes.includes(fileType)) {
                this.setState({ formError: "Invalid file type. Only pdf file is Allowed" });
                return;
            }

            const maxSize = 5 * 1024 * 1024; // 5MB
            if (fileSize > maxSize) {
                this.setState({ formError: "File size exceeds the 5MB limit." });
                return;
            }

            this.setState({ isLoading: true });

            const formData = new FormData();
            formData.append("userId", this.state.userId);
            formData.append("userName", this.state.userName);
            formData.append("fileId", this.state.fileId);
            formData.append("file", file);
            formData.append("filetype", fileType.replace('application/', ''));

            userService.EditPricingSheet(formData).then(postdata => {
                if (postdata.length > 0) {
                    if (postdata[0].code === '1') {
                        this.setState({ formSuccess: postdata[0].message });
                        this.props.changeInSheet();
                        setTimeout(() => {
                            this.props.hideModal();
                        }, 2000);
                    } else {
                        this.setState({ formError: postdata[0].message });
                    }
                } else {
                    this.setState({ formError: 'Error uploading file.' });
                }
            }).catch(() => {
                this.setState({ formError: "Error uploading file." });
            }).finally(() => {
                this.setState({ isLoading: false });
            });
        } catch (err) {
            this.setState({ isLoading: false, formError: "Unexpected error occurred." });
        }
    }

    handleFileChange(event) {
        this.setState({ formError: '', formSuccess: '', selectedFile: event.target.value });
    }
    triggerFileInput = () => {
        document.getElementById('file_upload').click();
    }
    render() {
        return (
            <div className="training_modal add_training_video">
                <div className="modal_wrapper">
                    {/* Header */}
                    <div className="header">
                        <h3>
                            Edit Sheet - {this.state.sheetTitle}
                        </h3>
                        <img src={close_btn} alt="Close" className="close-icon" onClick={this.props.hideModal} />
                    </div>

                    {/* Modal Body */}
                    <div className="modal_body">
                        <>
                            <div className="file-upload-wrapper" onClick={this.triggerFileInput}>
                                <div className="upload-text">{this.state.selectedFile ? 'Uploaded' : 'Upload'} <img src={this.state.selectedFile ? uploadSuccess : uploadIcon} /></div>
                                <input type="file" id="file_upload" name="file_upload" className="file-input" accept="application/pdf" onChange={this.handleFileChange.bind(this)} />
                            </div>
                        </>

                        {/* Error and Success Messages */}
                        {this.state.formError ? <div className="error">{this.state.formError}</div> : null}
                        {this.state.formSuccess ? <div className="success_msgs">{this.state.formSuccess}</div> : null}
                    </div>

                    {/* Footer */}
                    <div className="footer">
                        <button className={`btn red-btn ${this.state.isLoading ? "btn-loader" : ""}`} onClick={this.addDocMediaFile.bind(this)}>
                            Update Sheet
                        </button>
                        <button className="btn gray-btn" onClick={this.props.hideModal}>Cancel</button>
                    </div>
                </div>
            </div >
        );
    }
}
export default EditSheet;